import styled from "styled-components";

export const DocumentWrapper = styled.div`
    position: relative;
    min-height: 100px;
    overflow-x: scroll;

    canvas {
        margin: 0 auto;
    }

    .react-pdf__Page__annotations {
        display: none;
    }
`;

export const PageSeparator = styled.div`
    border-bottom: 1px solid rgba(206,208,213,0.5);
    margin: 72px 0;
`